import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { toast } from "sonner";
import App from "./App.tsx";
import "./index.css";
import "./lib/printMode";
import "./i18n";
import { installGlobalErrorToastInterceptor } from "./lib/errorMessage";
import { startAppVersionWatcher, installChunkLoadErrorHandler } from "./lib/appVersion";

installGlobalErrorToastInterceptor(toast);
installChunkLoadErrorHandler();
startAppVersionWatcher();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
